import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from './context/AuthContext'; 
import { Dp } from './context/DC';
import MainLayout from "./layout/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";

import UploadOverdraft from "./pages/UploadOverdraft";
import UploadSapMasterAr from "./pages/UploadSapMasterAr";
import UploadSapMasterAp from "./pages/UploadSapMasterAp";
import UploadSapArMap from "./pages/UploadSapArMap";
import UploadSapApMap from "./pages/UploadSapApMap";
import UploadFapMasterAr from "./pages/UploadFapMasterAr";
import UploadFapMasterAp from "./pages/UploadFapMasterAp";
import UploadBankAccount from "./pages/UploadBankAccount";

import UploadBankScb from "./pages/UploadBankScb";
import UploadBankKbank from "./pages/UploadBankKbank";
import UploadBankBbl from "./pages/UploadBankBbl";
import UploadBankBay from "./pages/UploadBankBay";
import UploadBankKtb from "./pages/UploadBankKtb";
import UploadBankTtb from "./pages/UploadBankTtb";
import UploadBankUob from "./pages/UploadBankUob";

import UploadBankKbankBillPayment from "./pages/P02008";
import UploadBankTtbBillPayment from "./pages/P02009";

import UploadDebtSapPayRec from "./pages/UploadDebtSapPayRec";
import L100034 from "./pages/P020119";

import CheckMaster from "./pages/CheckMaster";
import CheckBank from "./pages/CheckBank";
import CheckDebt from "./pages/CheckDebt";
import CheckMasterDetails from "./pages/CheckMasterDetails";
import CheckBankDetails from "./pages/CheckBankDetails";
import CheckDebtDetails from "./pages/CheckDebtDetails";

import FillBankStatement from "./pages/FillBankStatement";
import DisplayBookbank from "./pages/DisplayBookbank";

import Report03 from "./pages/Report03";
import Report04 from "./pages/Report04";

import ProcessBankSap from "./pages/ProcessBankSap";

import P08001 from "./pages/P08001";
import P08002 from "./pages/P08002";
import P08003 from "./pages/P08003";
import P08004 from "./pages/P08004";
import P08005 from "./pages/P08005";
import P08006 from "./pages/P08006";
import P08007 from "./pages/P08007";
import P08008 from "./pages/P08008";
import P08009 from "./pages/P08009";
import P08010 from "./pages/P08010";
import P08011 from "./pages/P08011";

import UploadConfig from "./pages/UploadConfig";

const App = () => {
  const { isAuthenticated } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };

  return (
    <Dp>
      <Router>
          <MainLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <Routes>
              <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
              <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />

              <Route path="/upload/overdraft" element={ <ProtectedRoute> <UploadOverdraft /> </ProtectedRoute> } />
              <Route path="/upload/sapmasterar" element={ <ProtectedRoute> <UploadSapMasterAr /> </ProtectedRoute> } />
              <Route path="/upload/sapmasterap" element={ <ProtectedRoute> <UploadSapMasterAp /> </ProtectedRoute> } />
              <Route path="/upload/saparmap" element={ <ProtectedRoute> <UploadSapArMap /> </ProtectedRoute> } />
              <Route path="/upload/sapapmap" element={ <ProtectedRoute> <UploadSapApMap /> </ProtectedRoute> } />
              <Route path="/upload/fapmasterar" element={ <ProtectedRoute> <UploadFapMasterAr /> </ProtectedRoute> } />
              <Route path="/upload/fapmasterap" element={ <ProtectedRoute> <UploadFapMasterAp /> </ProtectedRoute> } />
              <Route path="/upload/bankaccount" element={ <ProtectedRoute> <UploadBankAccount /> </ProtectedRoute> } />

              <Route path="/upload/bank-scb" element={ <ProtectedRoute> <UploadBankScb /> </ProtectedRoute> } />
              <Route path="/upload/bank-kbank" element={ <ProtectedRoute> <UploadBankKbank /> </ProtectedRoute> } />
              <Route path="/upload/bank-bbl" element={ <ProtectedRoute> <UploadBankBbl /> </ProtectedRoute> } />
              <Route path="/upload/bank-bay" element={ <ProtectedRoute> <UploadBankBay /> </ProtectedRoute> } />
              <Route path="/upload/bank-ktb" element={ <ProtectedRoute> <UploadBankKtb /> </ProtectedRoute> } />
              <Route path="/upload/bank-ttb" element={ <ProtectedRoute> <UploadBankTtb /> </ProtectedRoute> } />
              <Route path="/upload/bank-uob" element={ <ProtectedRoute> <UploadBankUob /> </ProtectedRoute> } />

              <Route path="/upload/bank-kbank-bill-payment" element={ <ProtectedRoute> <UploadBankKbankBillPayment /> </ProtectedRoute> } />
              <Route path="/upload/bank-ttb-bill-payment" element={ <ProtectedRoute> <UploadBankTtbBillPayment /> </ProtectedRoute> } />

              <Route path="/upload/debt-sappaymentreceive" element={ <ProtectedRoute> <UploadDebtSapPayRec /> </ProtectedRoute> } />
              <Route path="/upload/100034" element={ <ProtectedRoute> <L100034 /> </ProtectedRoute> } />

              <Route path="/check/master" element={ <ProtectedRoute> <CheckMaster /> </ProtectedRoute> } />
              <Route path="/check/bank" element={ <ProtectedRoute> <CheckBank /> </ProtectedRoute> } />
              <Route path="/check/debt" element={ <ProtectedRoute> <CheckDebt /> </ProtectedRoute> } />
              <Route path="/check/master-detail" element={ <ProtectedRoute> <CheckMasterDetails /> </ProtectedRoute> } />
              <Route path="/check/bank-detail" element={ <ProtectedRoute> <CheckBankDetails /> </ProtectedRoute> } />
              <Route path="/check/debt-detail" element={ <ProtectedRoute> <CheckDebtDetails /> </ProtectedRoute> } />

              <Route path="/bookbank/fill" element={ <ProtectedRoute> <FillBankStatement /> </ProtectedRoute> } />
              <Route path="/bookbank/display" element={ <ProtectedRoute> <DisplayBookbank /> </ProtectedRoute> } />

              <Route path="/review/statement" element={ <ProtectedRoute> <Report03 /> </ProtectedRoute> } />
              <Route path="/review/statement-unknown" element={ <ProtectedRoute> <Report04 /> </ProtectedRoute> } />

              <Route path="/process/reconcile" element={ <ProtectedRoute> <ProcessBankSap /> </ProtectedRoute> } />

              <Route path="/080001" element={ <ProtectedRoute> <P08001 /> </ProtectedRoute> } />
              <Route path="/080002" element={ <ProtectedRoute> <P08002 /> </ProtectedRoute> } />
              <Route path="/080003" element={ <ProtectedRoute> <P08003 /> </ProtectedRoute> } />
              <Route path="/080004" element={ <ProtectedRoute> <P08004 /> </ProtectedRoute> } />
              <Route path="/080005" element={ <ProtectedRoute> <P08005 /> </ProtectedRoute> } />
              <Route path="/080006" element={ <ProtectedRoute> <P08006 /> </ProtectedRoute> } />
              <Route path="/080007" element={ <ProtectedRoute> <P08007 /> </ProtectedRoute> } />
              <Route path="/080008" element={ <ProtectedRoute> <P08008 /> </ProtectedRoute> } />
              <Route path="/080009" element={ <ProtectedRoute> <P08009 /> </ProtectedRoute> } />     
              <Route path="/080010" element={ <ProtectedRoute> <P08010/> </ProtectedRoute> } />
              <Route path="/080011" element={ <ProtectedRoute> <P08011/> </ProtectedRoute> } />

              <Route path="/config/upload-config" element={ <ProtectedRoute> <UploadConfig /> </ProtectedRoute> } />
              <Route path="/config/user-register" element={ <ProtectedRoute> <Register /> </ProtectedRoute> } />

              <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} />} />
            </Routes>
          </MainLayout>
      </Router>
    </Dp>
  );
};

export default App;
